// Junction vertex schema
// A connection point where multiple pipes meet

import { z } from 'zod';
import { BaseVertexSchema } from '../base/vertex';
import { ValueWithUnitSchema } from '../base/common';

/**
 * Junction Vertex Schema
 * A connection point where multiple pipes meet. No resistance or special behavior.
 * 
 * This is the simplest vertex type - just a passive connection point
 * (ADR-0006: Simple device with direct properties)
 * 
 * @property elevation - Height of the junction (for pressure calculations)
 */
export const JunctionVertexSchema = BaseVertexSchema.extend({
  type: z.literal('junction'),
  elevation: ValueWithUnitSchema, // Height of the junction
});

export type JunctionVertex = z.infer<typeof JunctionVertexSchema>;

